module.exports = __webpack_public_path__ + "static/media/needs-5.2d96d1b0.png";